export default __webpack_public_path__ + "static/media/1886.e2addd47.png";